
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/release/[newsId]",
      function () {
        return require("private-next-pages/news/release/[newsId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/release/[newsId]"])
      });
    }
  